import { BaseEntity } from "yt-ng-framework";

export class Banka extends BaseEntity{
    constructor(){
        super();
    }

    Sifra:string = null;
    Naziv: string = null;
    Swift:string = null;
    Aba:string = null;
    CanadaTransitCode:string = null;
    Adresa: string = null;
    MestoID: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Sifra=input.Sifra;
        this.Naziv = input.Naziv;
        this.Swift=input.Swift;
        this.Aba=input.Aba;
        this.CanadaTransitCode=input.CanadaTransitCode;
        this.Adresa = input.Adresa;
        this.MestoID = input.MestoID; 
        return this;
    }

    Serialize(input: Banka){
        return input;
    }
}